import React from 'react';

export const Monitoring = React.lazy(() => import('./Monitoring'));
export * from './getReleaseNotes';
